import { Helmet } from "react-helmet";
import { products } from "utils/constants/constants";
import WhyUs from "components/MainPage/WhyUs";
import SingleProduct from "components/utils/SingleProduct";
import SubpageHero from "components/utils/SubpageHero";
import { useTranslation } from "react-i18next";

function ProductsPage() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet title={ `${ t(`productsPage.header.title`) } | Lark-strech` }/>
			<SubpageHero
				title={ t(`productsPage.header.title`) }
				description={ t(`productsPage.header.description`) }
			/>
			<div className="container">
				<div className="mt-24 mb-10 text-center text-gray-900 text-4xl md:font-5xl lg:text-6xl font-medium">
					{ t(`productsPage.productsList.title`) }
				</div>
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
					{ products.map(product => <SingleProduct textId={ product.textId } key={ product.id } product={ product }/>) }
				</div>
			</div>
			<WhyUs/>
		</>
	);
}

export default ProductsPage;